import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx'; // Import xlsx library
import AddClientsForm from './AddClientsForm';
import Clients from './Clients';
import EditClient from './EditClient';

function MyClients() {
  const [clients, setClients] = useState([]);
  const [showAddClientForm, setShowAddClientForm] = useState(false);
  const [editClientData, setEditClientData] = useState(null);
  const [showEditClientForm, setShowEditClientForm] = useState(false);

  useEffect(() => {
    getClients();
  }, []);

  const getClients = async () => {
    const token = localStorage.getItem("token");

    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/client`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });

      setClients(res.data);
    } catch (err) {
      console.error("Error fetching clients:", err);
    }
  };

  const openEditClientForm = (client) => {
    setEditClientData(client);
    setShowEditClientForm(true);
  };

  const handleFileUpload = (e) => {
  const file = e.target.files[0];
  const reader = new FileReader();

  reader.onload = (event) => {
    const data = new Uint8Array(event.target.result);
    const workbook = XLSX.read(data, { type: 'array' });
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];
    const json = XLSX.utils.sheet_to_json(worksheet);
    
    const clientsToUpload = json.map(row => {
      // Split comma-separated values for social media accounts
      const platforms = row.platform ? String(row.platform).split(',') : [];
      const smUsernames = row.sm_username ? String(row.sm_username).split(',') : [];
      const smPasswords = row.sm_password ? String(row.sm_password).split(',') : [];

      // Combine the split arrays into a structured array of objects
      const socialMediaAccounts = platforms.map((platform, index) => ({
        platform: platform.trim(),
        username: (smUsernames[index] || '').trim(),
        password: (smPasswords[index] || '').trim(),
      }));
      
      // Split comma-separated values for website credentials
      const siteUrls = row.siteUrl ? String(row.siteUrl).split(',') : [];
      const webUsernames = row.web_username ? String(row.web_username).split(',') : [];
      const appPasswords = row.appPassword ? String(row.appPassword).split(',') : [];

      // Combine the split arrays into a structured array of objects
      const websiteCredentials = siteUrls.map((siteUrl, index) => ({
        siteUrl: siteUrl.trim(),
        username: (webUsernames[index] || '').trim(),
        appPassword: (appPasswords[index] || '').trim(),
      }));

      return {
        clientName: row.clientName,
        company: row.company,
        group: row.group,
        Email: row.Email,
        contact: row.contact,
        contactalt: row.contactalt,
        building: row.building,
        street: row.street,
        city: row.city,
        district: row.district,
        state: row.state,
        pincode: row.pincode,
        caseId: row.caseId,
        socialMediaAccounts,
        websiteCredentials,
      };
    });

    bulkUploadClients(clientsToUpload);
  };

  reader.readAsArrayBuffer(file);
};

  const bulkUploadClients = async (clientsData) => {
    const token = localStorage.getItem("token");

    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/client/bulk-upload`, clientsData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      });
      alert("Clients uploaded successfully!");
      getClients(); // Refresh the list of clients
    } catch (err) {
      console.error("Error bulk uploading clients:", err);
      alert("Failed to upload clients.");
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6 text-white">Client Dashboard</h1>

      <div className="flex space-x-4 mb-6">
        <button
          onClick={() => setShowAddClientForm(!showAddClientForm)}
          className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
        >
          {showAddClientForm ? "Close Form" : "Add Client"}
        </button>
        <label className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 cursor-pointer">
          Upload Excel
          <input type="file" onChange={handleFileUpload} className="hidden" accept=".xlsx, .xls" />
        </label>

         <a
                                href="sampleforclients.xlsx"
                                download="sampleforclients.xlsx"
                                style={{ color: 'white', textDecoration: 'underline' }}
                            >
                                Download Sample Excel Sheet
                            </a>
      </div>

      {showAddClientForm && (
        <AddClientsForm closeModal={() => setShowAddClientForm(false)} onClientAdded={getClients} />
      )}

      <Clients clients={clients} onClientDeleted={getClients} openEditClientForm={openEditClientForm} />

      {showEditClientForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-xl shadow-xl max-w-lg w-full">
            <EditClient client={editClientData} closeModal={() => setShowEditClientForm(false)} onClientUpdated={getClients} />
          </div>
        </div>
      )}
    </div>
  );
}

export default MyClients;